module.exports = __webpack_public_path__ + "cb4af1eca21ee61fed457ede63d7a057.fbx";